import { jsx as _jsx } from "react/jsx-runtime";
import NextImage from 'next/image';
export const Image = ({ src, alt, href, width, height, blurDataURL }) => {
    let render;
    if (width === undefined || height === undefined) {
        render = _jsx("img", { src: src, alt: alt });
    }
    else {
        render = (_jsx(NextImage, { src: src, alt: alt ?? '', placeholder: blurDataURL ? 'blur' : undefined, blurDataURL: blurDataURL, width: width, height: height }));
    }
    if (href) {
        render = _jsx("a", { href: href, children: render });
    }
    return render;
};
